import React from "react";
import { Card, CardContent } from "./ui/card";
import YouTubeEmbed from "./YouTubeEmbed";

const YouTubeSection = () => {
  return (
    <section 
      className="py-20 relative"
      style={{
        backgroundImage: 'linear-gradient(rgba(0,0,0,0.8), rgba(0,0,0,0.8)), url("https://customer-assets.emergentagent.com/job_xd-project-landing/artifacts/qs7k9g9s_Youtube-Background.jpg")',
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'scroll'
      }}
    >
      <div className="container mx-auto px-4">
        {/* Header Section */}
        <div className="text-center mb-12">
          <img 
            src="https://customer-assets.emergentagent.com/job_xd-project-landing/artifacts/787p3v0r_KitcoMining-Youtube-Logos.svg"
            alt="Kitco Mining YouTube"
            className="max-w-lg mx-auto mb-8"
          />
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Watch Kitco Mining Channel
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-12">
            Stay up-to-date with the latest mining news, market analysis, and exclusive interviews with industry leaders.
          </p>
        </div>

        {/* YouTube Player - Center Stage */}
        <div className="flex justify-center mb-16">
          <div className="relative">
            <YouTubeEmbed 
              playlistId="PLzpGB1bx9Uxc_qC_-XeKyqMYRsJEFJIyj" 
              title="Kitco Mining Channel" 
              width={560}
              height={380}
            />
            {/* Glow effect */}
            <div className="absolute -inset-2 bg-gradient-to-r from-yellow-500/20 to-red-500/20 rounded-xl blur-md -z-10"></div>
          </div>
        </div>

        {/* Hosts and QR Code Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16 max-w-4xl mx-auto">
          {/* Hosts */}
          <Card className="bg-gray-800/70 border-yellow-500/20 backdrop-blur-sm hover:bg-gray-700/70 transition-colors duration-300">
            <CardContent className="p-8">
              <h3 className="text-2xl font-bold text-white mb-6 text-center">
                Your Hosts
              </h3>
              
              <div className="flex justify-center mb-6">
                <img 
                  src="https://customer-assets.emergentagent.com/job_xd-project-landing/artifacts/cv5tsrxl_PH-JS.png"
                  alt="Jeremy Szafron and Paul Harris"
                  className="max-w-full h-auto rounded-lg shadow-lg"
                />
              </div>
              
              <div className="text-center">
                <h4 className="text-xl font-bold text-yellow-500 mb-2">
                  Jeremy Szafron & Paul Harris
                </h4>
                <p className="text-gray-300 text-sm">
                  Mining Anchors and Journalists
                </p>
              </div>
            </CardContent>
          </Card>

          {/* QR Code */}
          <Card className="bg-gray-800/70 border-yellow-500/20 backdrop-blur-sm hover:bg-gray-700/70 transition-colors duration-300">
            <CardContent className="p-8 text-center">
              <h3 className="text-2xl font-bold text-white mb-6">
                Subscribe Now
              </h3>
              
              <div className="flex justify-center mb-6">
                <img 
                  src="https://customer-assets.emergentagent.com/job_xd-project-landing/artifacts/j6aoc8mj_QR.png"
                  alt="QR Code - Kitco Mining YouTube"
                  className="w-32 h-32 bg-white p-2 rounded shadow-lg"
                />
              </div>
              
              <p className="text-gray-300 text-sm mb-4">
                Scan for quick access to our YouTube channel
              </p>
              
              <button 
                className="text-red-500 hover:text-red-400 font-semibold text-sm underline transition-colors duration-300"
                onClick={() => window.open('https://www.youtube.com/@KitcoMining', '_blank')}
              >
                Or visit youtube.com/@KitcoMining
              </button>
            </CardContent>
          </Card>
        </div>

        {/* Stats Bar */}
        <div className="flex flex-col md:flex-row justify-center items-center gap-8 md:gap-16 pt-8 border-t border-gray-700/50">
          <div className="text-center group">
            <div className="text-3xl font-bold text-yellow-500 group-hover:scale-110 transition-transform duration-300">
              45K+
            </div>
            <div className="text-white text-sm mt-2">
              Subscribers
            </div>
          </div>
          
          <div className="hidden md:block w-px h-10 bg-yellow-500/30"></div>
          
          <div className="text-center group">
            <div className="text-3xl font-bold text-yellow-500 group-hover:scale-110 transition-transform duration-300">
              2M+
            </div>
            <div className="text-white text-sm mt-2">
              Views This Year
            </div>
          </div>
          
          <div className="hidden md:block w-px h-10 bg-yellow-500/30"></div>
          
          <div className="text-center group">
            <div className="text-3xl font-bold text-yellow-500 group-hover:scale-110 transition-transform duration-300">
              Daily
            </div>
            <div className="text-white text-sm mt-2">
              New Content
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default YouTubeSection;